export function formatDisplayName(
  ...parts: Array<string | null | undefined>
): string {
  return parts
    .flatMap((part) => (part || "").trim().split(/\s+/))
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
